import { observable, makeObservable } from 'mobx';

export default class Distribution {
  project;
  task;
  code;
  name = "";

  constructor(project, task, code, name) {
    this.task = task;
    this.code = code;
    this.project = project;
    this.name = name;

    makeObservable(this, {
      name: observable
    })
  }

  toJS() {
    return {
      code: this.code,
      name: this.name,
    }
  }

  static fromJS(object) {
    const distribution = new Distribution();
    if (object != null) {
      distribution.code = object.code;
      distribution.name = object.name;
    }
    return distribution;
  }
}